import type { IconProps } from 'common-types';

const AngleLeft = ({ width = 24, height = 24, fill }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill={fill ?? 'none'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.91403 11.9988L15.207 17.2918C15.3945 17.4793 15.4998 17.7336 15.4998 17.9988C15.4998 18.264 15.3945 18.5183 15.207 18.7058C15.0195 18.8933 14.7652 18.9986 14.5 18.9986C14.2349 18.9986 13.9806 18.8933 13.793 18.7058L7.79303 12.7058C7.60556 12.5183 7.50024 12.264 7.50024 11.9988C7.50024 11.7336 7.60556 11.4793 7.79303 11.2918L13.793 5.29181C13.9806 5.10434 14.2349 4.99902 14.5 4.99902C14.7652 4.99902 15.0195 5.10434 15.207 5.29181C15.3945 5.47934 15.4998 5.73365 15.4998 5.99881C15.4998 6.26397 15.3945 6.51828 15.207 6.70581L9.91403 11.9988Z"
      fill={fill ?? '#14171A'}
    />
  </svg>
);

export default AngleLeft;
